import React from 'react'
import * as R from 'ramda'
import { ThemeProvider } from 'styled-components'
import { inputColors } from 'sidecar-design-library'

import enhance from './enhance'
import {
  Wrapper,
  StyledIcon,
  ValidationIcon,
  Label,
  Input,
  IconLabel,
  RemoveLabel,
  RemoveIcon,
} from './styles'
import isReactComponent from './utils'

export const InputText = ({
  clearSSN,
  label,
  plainIcon,
  placeholder,
  beforeIcon,
  afterIcon,
  innerRef,
  input: { name, value, onChange, ...restInput },
  meta,
  meta: { active, visited, touched, error },
  error: customError,
  validator,
  clearLabel,
  wideLabel,
  readOnly = false,
  remove = false,
  ...rest
}) => (
  <ThemeProvider
    theme={
      touched && (error || customError)
        ? inputColors.inputTextError
        : inputColors.inputTextDefault
    }
  >
    <Wrapper className="inputWrapper">
      {R.cond([
        [R.is(String), () => <StyledIcon before name={beforeIcon} />],
        [isReactComponent, Component => <Component />],
        [React.isValidElement, R.identity],
        [R.isNil, () => null],
      ])(beforeIcon)}

      <Input
        id={name}
        visited={visited || !R.isNil(value)}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        name={name}
        beforeIcon={beforeIcon}
        validator={validator}
        {...restInput}
        {...rest}
        labelAsPlaceholder={!!label}
        readOnly={readOnly}
        ref={innerRef}
        disabled={readOnly && 'disabled'}
      />
      {label && (
        <Label
          htmlFor={name}
          considerIcon={beforeIcon}
          {...meta}
          clear={clearLabel}
          wide={wideLabel}
        >
          {label}
        </Label>
      )}

      {R.cond([
        [R.is(String), () => <StyledIcon after name={afterIcon} />],
        [isReactComponent, Component => <Component />],
        [React.isValidElement, R.identity],
        [R.isNil, () => null],
      ])(afterIcon)}

      {remove && (
        <RemoveLabel>
          <RemoveIcon name="x" onClick={clearSSN} />
        </RemoveLabel>
      )}

      {!active && validator && touched && (
        <IconLabel after htmlFor={name}>
          <ValidationIcon
            name={error ? 'x' : 'checkmark'}
            plainIcon={plainIcon}
          />
        </IconLabel>
      )}
    </Wrapper>
  </ThemeProvider>
)

export default enhance(InputText)
